var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.81 150.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: gray;\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 64.91,
    cy: 38.72,
    rx: 33.06,
    ry: 33.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.55,145.58c-1.62-32.16-27.71-57.73-59.65-57.73S6.88,113.42,5.26,145.58H124.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAsset);
export default __webpack_public_path__ + "static/media/userAsset.443f7ae1071d595b4c338b0b6f61af68.svg";
export { ForwardRef as ReactComponent };